<template>
  <div class="blocked-container vermebg">
    <div class="blocked-icon">
      <svg viewBox="0 0 24 24" width="120" height="120">
        <path fill="currentColor" d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4M7,11H17V13H7V11Z" />
      </svg>
    </div>
    <h1>ACESSO BLOQUEADO - VERME DETECTADO!</h1>
    <div class="motivational-message">
      <p class="verme-title">VOCÊ É APENAS UM VERME QUE SÓ FAZ PESO NA TERRA</p>
      <p>Assim como os vermes que sobrevivem comendo isopor, você é só um parasita tentando se alimentar do trabalho dos outros.</p>
      <p>QUEM NASCEU PARA SER UMA CÓPIA BARATA.... JAMAIS SERÁ 01 DALE TECH REAL OFICIAL</p>
      <p>Demitido e ainda tentando viver do meu trabalho? Patético como um verme que não sabe fazer nada além de consumir lixo.</p>
      <p>Assim como os vermes, você só sabe engolir o que os outros criam. INCAPAZ DE PRODUZIR ALGO ORIGINAL!</p>
      <p class="proverbio">"人无信不立" - "Homem sem lealdade não é nada além de um parasita." - Provérbio Chinês</p>
      <p>Saiu pela porta dos fundos e agora rasteja como um verme tentando corromper quem é de verdade </p>
      <p>Tão desesperado que rasteja de volta, sem dignidade, sem talento, só um verme tentando sugar o que não é seu.</p>
      <p>Até um verme que come lixo tem mais valor que alguém que tenta roubar trabalho alheio!</p>
      <p class="proverbio">"不要盡信雙重面孔的人" - "Aquele que mendiga contatos como um cão é o mesmo que rasteja no chão por migalhas." - Provérbio Chinês</p>
      <p>Suas palavras são tão vazias quanto suas promessas. A mentira é sua língua nativa, e o Diabo, seu mestre e deus.</p>
      <p>Quer acesso ao meu telegram também? KKKKKKKKKKK</p>
      <p>LEALDADE NÃO SE COMPRA!</p>
    </div>
    <div class="video-container">
      <iframe 
        width="560" 
        height="315" 
        src="https://www.youtube.com/embed/yTsPKhLAQmk?autoplay=1&mute=0&enablejsapi=1&version=3&playerapiid=ytplayer" 
        title="YouTube video player" 
        frameborder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
        allowfullscreen
        autoplay="true"
        muted="false"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlockedPage',
};
</script>

<style scoped>
.blocked-container {
  max-width: 800px;
  margin: 5% auto;
  padding: 30px;
  text-align: center;
  box-shadow: 0 0 20px rgba(255, 0, 0, 0.4);
  border-radius: 8px;
  background-color: rgba(0, 0, 0, 0.85);
  color: #ccc;
}

.vermebg {
  position: relative;
}

.vermebg::before {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('https://st2.depositphotos.com/1830989/10488/i/450/depositphotos_104889000-stock-photo-many-mealworms-background.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  opacity: 0.3;
  z-index: -1;
}

.blocked-icon {
  color: #e74c3c;
  margin: 0 auto 20px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

h1 {
  color: #e74c3c;
  margin-bottom: 20px;
  font-size: 1.8rem;
  text-align: center;
}

p {
  font-size: 1.1rem;
  line-height: 1.5;
}

.motivational-message {
  margin: 30px 0;
  padding: 20px;
  background-color: rgba(231, 76, 60, 0.9);
  color: white;
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(255, 0, 0, 0.8);
  position: relative;
  z-index: 1;
  overflow: hidden;
}

.motivational-message::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('https://st2.depositphotos.com/1830989/10488/i/450/depositphotos_104889000-stock-photo-many-mealworms-background.jpg');
  background-size: cover;
  background-position: center;
  opacity: 0.3;
  z-index: -1;
}

.verme-title {
  font-size: 2rem !important;
  text-transform: uppercase;
  font-weight: 900;
  color: #ffff00;
  text-shadow: 2px 2px 4px #000000;
  margin-bottom: 20px !important;
  letter-spacing: 1px;
  animation: pulse 1.5s infinite;
}

.proverbio {
  font-size: 1.5rem !important;
  font-style: italic;
  font-weight: 600;
  color: #ffcc00;
  text-shadow: 1px 1px 2px #000000;
  margin: 15px 0 !important;
  border-left: 3px solid #ffcc00;
  padding-left: 15px;
  letter-spacing: 0.5px;
}

.motivational-message h2 {
  font-size: 2rem;
  margin-bottom: 15px;
  font-weight: bold;
  text-shadow: 1px 1px 3px rgba(0,0,0,0.5);
}

.motivational-message p {
  font-size: 1.3rem;
  font-weight: bold;
  margin-bottom: 10px;
  line-height: 1.5;
}

.video-container {
  margin-top: 30px;
  position: relative;
  padding-bottom: 56.25%; /* 16:9 Aspect Ratio */
  height: 0;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  max-width: 100%;
  text-align: center;
}

.warning {
  color: #ffcc00;
  font-weight: bold;
  font-size: 1.2rem;
  text-align: center;
  padding: 20px;
  background-color: rgba(255, 204, 0, 0.1);
  border: 1px solid #ffcc00;
  border-radius: 5px;
}

.video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 3px solid #e74c3c;
  box-shadow: 0 0 20px rgba(231, 76, 60, 0.5);
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}

/* Animação para efeito de rastejamento como verme */
@keyframes wriggle {
  0% { transform: translateX(-3px); }
  50% { transform: translateX(3px); }
  100% { transform: translateX(-3px); }
}

.motivational-message p {
  animation: wriggle 3s infinite;
  animation-delay: calc(var(--i, 0) * 0.5s);
  position: relative;
  text-shadow: 1px 1px 3px rgba(0,0,0,0.8);
}
</style>
